var _ellipse, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.961,
    cy: 12,
    rx: 11.961,
    ry: 12,
    fill: "#3555F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.47 3.528a1.31 1.31 0 00-1.858.572L9.81 16.004 7.186 11.79a1.338 1.338 0 00-1.847-.426 1.347 1.347 0 00-.428 1.852l3.953 6.346a1.338 1.338 0 002.367-.18c.113-.108.209-.24.283-.39L18.079 5.52a1.55 1.55 0 00-.608-1.993z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/checked.de2a77ea804a5dcae974165c9530a12d.svg";
export { SvgChecked as ReactComponent };